import {connect} from 'react-redux';
import React, {Component, Fragment} from 'react';
import {actions as project} from '../reducers/project';
import {actions as labelCollection} from '../reducers/labelCollection';
import Modal from "../components/general/Modal";
import _ from "lodash";
import {Link} from "react-router-dom";
import * as settings from "../services/settings";

@connect(
	state => {
		return {
			selectedProject: state.project.selected,
			labelCollections: state.labelCollection.labelCollections,
            hasProjectFilter: state.project.hasProjectFilter,
            highlightedLabelCollection: state.labelCollection.highlighted
		}
	},
	dispatch => {
		return {
			deleteProject: projectObject => dispatch(project.delete(projectObject)),
			importProject: projectObject => dispatch(project.import(projectObject)),
			renderProject: projectObject => dispatch(project.render(projectObject)),
			fetchLabelCollections: () => dispatch(labelCollection.fetch()),
			deleteLabelCollection: (labelCollectionObject) => dispatch(labelCollection.delete(labelCollectionObject)),
			finishLanguage: (language, labelCollection) => dispatch(project.finishLanguages(language, labelCollection)),
            enableProjectFilter: () => dispatch(project.enableProjectFilter()),
            disableProjectFilter: () => dispatch(project.disableProjectFilter()),
            updateHighlightLabelCollection: (lc) => dispatch(labelCollection.highlightLabelCollection(lc))
		};
	})
export default class ProjectDetail extends Component {

	constructor(props){
		super(props);

        this.labelCollectionRef = React.createRef();
	}

	componentWillReceiveProps(nextProps, nextContext) {
		if (
			nextProps.selectedProject !== null && (
				(this.props.selectedProject === null)
				||
				(nextProps.selectedProject.name !== this.props.selectedProject.name)
			)
		) {
			this.props.fetchLabelCollections();
		}
	}

	componentDidMount() {
		if (this.props.labelCollections.length === 0 && this.props.selectedProject) {
			this.props.fetchLabelCollections();
		}

        if(this.labelCollectionRef.current)
        {
            this.labelCollectionRef.current.scrollIntoView({behavior: "smooth", block: "center"})
        }
	}

	hasLabelCollectionTranslatedAll(labelCollection) {

		let hasFalse = false;
		_.map(this.props.selectedProject.languages, (language, key) => {
			const labelCollectionLanguage = _.find(labelCollection.languages, {identifier: language});
			if (labelCollectionLanguage) {
				if (labelCollection.totalLabels !== labelCollectionLanguage.translatedLabels)
				{
					hasFalse = true;
				}
			}
		})
		return !hasFalse;
	}

	getFilteredLabelCollections() {
		let labelCollections = [];

		this.props.labelCollections.map((labelCollection) => {
			if(!this.hasLabelCollectionTranslatedAll(labelCollection)) {
				labelCollections.push(labelCollection);
			}
		});
		return labelCollections
	}

	finishAllByLanguage(labelCollections, language) {
		labelCollections.map((labelCollection) => {
			this.props.finishLanguage(language, labelCollection, this.props.selectedProject)
		})
	}

	renderCountOfLockedLanguages(language) {
		let labelCollectionsWithLockedLanguages = this.props.labelCollections.filter(labelCollection => labelCollection.languages.filter(filterLanguage => filterLanguage.lockedBy === true && filterLanguage.identifier === language).length > 0 );
		return(
			<div className='dropdown d-inline'>
				<span title='Locked by me' id='dropdownMenuSpan' data-toggle='dropdown' className='badge badge-pill badge-primary dropdown-toggle'>{labelCollectionsWithLockedLanguages.length> 0?labelCollectionsWithLockedLanguages.length:null}</span>
				<div className='dropdown-menu dropdown-menu-right' aria-labelledby='dropdownMenuSpan'>
					<button onClick={() => this.finishAllByLanguage(labelCollectionsWithLockedLanguages, language)} className='dropdown-item' style={{'zIndex': '2000'}}>Save my edited collections in this language</button>
				</div>
			</div>
		)
	}

	updateFilter(isActive) {
	    if (isActive) {
	        this.props.enableProjectFilter()
        }else {
	        this.props.disableProjectFilter()
        }
    }

	render() {
		const collectionList = this.props.selectedProject && this.props.labelCollections.length ? (
			<div className="card-body" style={{'padding-top': '0px'}}>
				<div>
					<table className="table table-fixed">
						<thead>
						<tr>
							<th style={{'position': 'sticky', 'top': '0px', 'backgroundColor': 'white', 'z-index': '999'}}>Label Collections</th>
							{_.map(this.props.selectedProject.languages, (language, key) => (
								<th style={{'position': 'sticky', 'top': '0px', 'backgroundColor': 'white', 'z-index': '999', 'white-space': 'nowrap'}} key={key}>{language} {this.renderCountOfLockedLanguages(language)}</th>))}
							<th style={{'position': 'sticky', 'top': '0px', 'backgroundColor': 'white', 'zIndex': '999'}}></th>
						</tr>
						<tr style={{borderBottom: "2px solid black"}}>
							<td style={{'position': 'sticky', 'top': '42px', 'backgroundColor': 'white', 'z-index': '999'}} className={"border-top-0"}>
								<input id='hide_filter' type='checkbox' checked={this.props.hasProjectFilter} onChange={(event) => {this.updateFilter(event.target.checked)}}/>
								<label style={{'margin-left': '5px'}} htmlFor='hide_filter'>Hide fully translated collections</label>
							</td>
							{
								_.map(this.props.selectedProject.languages, (language, key) => {
									let countTranslatedLabels = 0;
									let countTotalLabels = 0;
									_.map(!this.props.hasProjectFilter?this.props.labelCollections:this.getFilteredLabelCollections(), (labelCollection) => {
										const labelCollectionLanguage = _.find(labelCollection.languages, {identifier: language});
										if (!!labelCollectionLanguage) {
											countTotalLabels += labelCollection.totalLabels;
											countTranslatedLabels += labelCollectionLanguage.translatedLabels;
										}
									});
									return (
										<td className={"border-top-0"} style={{"fontWeight": countTotalLabels === countTranslatedLabels ? '' : "bold", 'position': 'sticky', 'top': '42px', 'backgroundColor': 'white'}}
											key={key}>
											{countTranslatedLabels}{countTotalLabels === countTranslatedLabels ? "" : "/" + countTotalLabels + " (" + _.floor(countTranslatedLabels / countTotalLabels * 100) + "%)"}
										</td>
									);
								})
							}
							<td style={{'position': 'sticky', 'top': '42px', 'backgroundColor': 'white', 'zIndex': '100'}} className={"border-top-0"}/>
						</tr>
						</thead>
						<tbody>
						{
							_.map(!this.props.hasProjectFilter?this.props.labelCollections:this.getFilteredLabelCollections(), (labelCollection, key) => (
								<tr className={'testcafe-labelcollection-' + labelCollection.identifier.split(':').splice(-1) }
                                    key={key}
                                    style={(this.props.highlightedLabelCollection&&this.props.highlightedLabelCollection.identifier===labelCollection.identifier?{'background-color': 'rgba(245, 90, 14, 0.5)'}:null)}
                                    ref={this.props.highlightedLabelCollection&&this.props.highlightedLabelCollection.identifier===labelCollection.identifier?this.labelCollectionRef:null}
                                    onClick={() => this.props.updateHighlightLabelCollection(labelCollection)}
                                >
									<td title={labelCollection.identifier}>
										<Link style={{"textDecoration": "none"}} to={'/show/' + encodeURIComponent(this.props.selectedProject.name) + '/' + encodeURIComponent(labelCollection.identifier)}
											  className="text-dark text-decoration-none">
											{labelCollection.displayName !== ""?(
												<div>
													<div>
														<b>{labelCollection.displayName}
														</b>
													</div>
													<small>{labelCollection.identifier.split(':').splice(-1)}</small>
												</div>
											):(<div>{labelCollection.identifier.split(':').splice(-1)}</div>)}
										</Link>
									</td>
									{
										_.map(this.props.selectedProject.languages, (language, key) => {
											const labelCollectionLanguage = _.find(labelCollection.languages, {identifier: language});
											if (labelCollectionLanguage) {
												return (
													<td style={{"fontWeight": labelCollection.totalLabels === labelCollectionLanguage.translatedLabels ? "" : "bold"}}
														key={key}>
														{labelCollectionLanguage.translatedLabels}{labelCollection.totalLabels === labelCollectionLanguage.translatedLabels ? "" : "/" + labelCollection.totalLabels}
														{
															+labelCollectionLanguage.translatedLabels !== labelCollection.totalLabels ?
																<span> ({_.round(labelCollectionLanguage.translatedLabels / labelCollection.totalLabels * 100) + '%'})</span>
																: null
														}
														{
															labelCollectionLanguage.lockedBy ? (
																labelCollectionLanguage.lockedBy === true ? (
																	<i style={{color: '#1e7e34'}} data-toggle="tooltip"
																	   className="fa fa-lock" title="Locked by me"/>
																) : (
																	<i data-toggle="tooltip" className="fa fa-lock"
																	   title={'Locked by ' + labelCollectionLanguage.lockedBy}/>
																)
															) : null
														}
													</td>
												);
											} else {
												return <td key={key}>x</td>;
											}
										})
									}
									<td>

										{settings.showAdminFunctions() ? (
											<Fragment>
												<Link
													to={'/edit/' + encodeURIComponent(this.props.selectedProject.name) + '/' + encodeURIComponent(labelCollection.identifier)}
													className="btn btn-link btn-icon btn-sm edit"
													title="edit">
													<i className="fa fa-edit"/>
												</Link>
												<button className="btn btn-danger btn-link btn-icon btn-sm"
														data-target={'#delete-labelCollection-' + key}
														data-toggle="modal"
														title="delete">
													<i className="fa fa-times"/>
												</button>

												<Modal identifier={'delete-labelCollection-' + key}
													   callBack={() => this.props.deleteLabelCollection(labelCollection)}
													   title="Danger Zone"
													   text={'Delete labelCollection "' + labelCollection.identifier + '"?'}
													   actionText="delete"
													   dismissText="never mind"
												/>
											</Fragment>
										) : null}
									</td>
								</tr>
							))
						}
						</tbody>
					</table>
				</div>
			</div>
		) : null;

		return this.props.selectedProject ? (
			<div className="card m-0" style={{height: 'calc(100vh - 123px)', 'overflow-y': 'auto'}}>
				<Modal
					identifier="delete-modal-project"
					callBack={() => {
						this.props.deleteProject(this.props.selectedProject);
						this.props.history.push('/');
					}}
					title="Danger Zone"
					text={'Please confirm before the project "' + this.props.selectedProject.name + '" is deleted.'}
					dismissText="Never mind"
					actionText="Delete"
				/>

				<Modal
					identifier="import-modal-project"
					callBack={() => {
						this.props.importProject(this.props.selectedProject)
					}}
					title={"Do you really want to import " + this.props.selectedProject.name}
					dismissText="Never mind"
					actionText="Import"
				/>

				<Modal
					identifier="render-modal-project"
					callBack={() => {
						this.props.renderProject(this.props.selectedProject)
					}}
					title={"Do you really want to render " + this.props.selectedProject.name}
					dismissText="Never mind"
					actionText="Render"
				/>

				{collectionList}
			</div>
		) : null;
	}
}



// WEBPACK FOOTER //
// ./React/src/screens/ProjectDetail.js